// @ts-nocheck
// VENDORED from mobile: app/constants/Colors.ts — do not edit here; edit the mobile file and run scripts/sync-shared.sh
/**
 * Color palette for light and dark themes
 */

// RGBA tuple type for picker colors
type RGBATuple = [number, number, number, number];

// Theme color interface
export interface ThemeColors {
	background: string;
	primary: string;
	secondary: string;
	text: string;
	accent: string;
	accentTwo: string;
	buttonText: string;
	buttonBackground: string;
	borderColor: string;
	green: string;
	teal: string;
	red: string;
	orange: string;
	blue: string;
	yellow: string;
	white: string;
	worst: string;
	bad: string;
	neutral: string;
	good: string;
	best: string;
	altGrey: string;
	pickerBg: RGBATuple;
	pickerBase: RGBATuple;
	carbs: string;
	fats: string;
	proteins: string;
	calories: string;
	trans: string;
	// Allow additional theme-specific colors
	tabInactive?: string;
	[key: string]: string | RGBATuple | undefined;
}

const Colors: ThemeColors = {
	background: '#FFFFFF',
	primary: '#E74C3C',
	secondary: '#F5F6F7',
	text: '#333333',
	accent: '#FF5733',
	accentTwo: '#FFC1C1',
	buttonText: '#FFFFFF',
	buttonBackground: '#E74C3C',
	borderColor: '#CCCCCC',
	green: '#00b894',
	teal: '#68c3b9',
	red: '#e17055',
	orange: '#FFC107',
	blue: '#64a4d3',
	yellow: '#fdcb6e',
	white: '#FFF',
	worst: '#E28582',
	bad: '#F3B682',
	neutral: '#F8DB49',
	good: '#83D098',
	best: '#57A19D',
	altGrey: '#EBEEF3',
	pickerBg: [224, 52, 46, 1],
	pickerBase: [255, 255, 255, 1],
	carbs: '#3498db',
	fats: '#f1c40f',
	proteins: '#E74C3C',
	calories: '#16a085',
	trans: 'rgba(255,255,255,0.9)'
};

const Dark: ThemeColors = {
	background: '#080808',
	primary: '#E74C3C',
	secondary: '#1e1e1e',
	text: '#FFFFFF',
	accent: '#FF5733',
	accentTwo: '#FFC1C1',
	buttonText: '#FFFFFF',
	buttonBackground: '#E74C3C',
	borderColor: '#1A1A1A',
	green: '#00b894',
	teal: '#68c3b9',
	red: '#e17055',
	orange: '#FFC107',
	blue: '#64a4d3',
	yellow: '#fdcb6e',
	white: '#FFF',
	worst: '#E28582',
	bad: '#F3B682',
	neutral: '#F8DB49',
	good: '#83D098',
	best: '#57A19D',
	altGrey: '#2F2F2F',
	pickerBg: [224, 52, 46, 1],
	pickerBase: [0, 0, 0, 1],
	carbs: '#3498db',
	fats: '#f1c40f',
	proteins: '#E74C3C',
	calories: '#16a085',
	trans: 'rgba(0,0,0,0.9)'
};

export { Colors, Dark };
